import { faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '@module/lib/utils';
import * as React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onClear?: () => void;
  containerClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, onClear, containerClassName, ...props }, ref) => {
    return (
      <div className={cn('flex h-12 rounded-lg border border-borderBg03', containerClassName)}>
        <input
          type={type}
          className={cn(
            'h-full w-full px-3 py-2 text-[16px] text-baseFg ring-offset-background file:border-0 file:bg-transparent file:font-medium file:text-[16px] placeholder:text-borderBg03 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
            className,
          )}
          ref={ref}
          {...props}
        />
        {onClear && !!props.value && (
          <button type='button' onClick={onClear} className='mx-3'>
            <FontAwesomeIcon icon={faXmarkCircle} className='text- h-[17px] w-[17px] text-gray-300' />
          </button>
        )}
      </div>
    );
  },
);
Input.displayName = 'Input';

export { Input };
